// extracted by css-extract-rspack-plugin
export default {"moreTenanciesPill":"NextRoomButton-module__moreTenanciesPill"};